const convertTimeToText = (time) => {
    var text = "";
    if (time < 10) {
        text = "0" + time.toString();
    } else {
        text = time.toString();
    }
    return text;
};

export { convertTimeToText };
